const configuration = {
    //baseURL : "http://localhost:5000/api/"
    baseURL : "http://backend.gswire.com/api/"
}
export default configuration;